import { GraduationCap, CheckCircle2, ExternalLink, CalendarClock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useSite } from "@/context/SiteContext";

const requirements = [
  "Fotokopi Akta Kelahiran",
  "Fotokopi Kartu Keluarga (KK)",
  "Pas Foto terbaru ukuran 3x4",
  "Berusia minimal 6 tahun",
];

const PpdbDialog = ({ trigger }) => {
  const { activeReg } = useSite();
  const hasLink = activeReg && activeReg.url;

  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-lg" data-testid="ppdb-dialog">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-100">
            <GraduationCap className="h-7 w-7 text-emerald-700" />
          </div>
          <DialogTitle className="text-center font-heading text-xl">
            Penerimaan Peserta Didik Baru
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="rounded-xl bg-emerald-50 p-4 text-center">
            <div className="flex items-center justify-center gap-2 text-emerald-800">
              <CalendarClock className="h-4 w-4" />
              <span className="font-heading text-lg font-bold">
                Tahun Pelajaran {activeReg?.year || "2026/2027"}
              </span>
            </div>
            {activeReg?.note && <p className="mt-1 text-sm text-emerald-700">{activeReg.note}</p>}
          </div>

          <div>
            <p className="mb-2 text-sm font-semibold text-slate-700">Persyaratan Pendaftaran:</p>
            <ul className="space-y-2">
              {requirements.map((r) => (
                <li key={r} className="flex items-start gap-2 text-sm text-slate-600">
                  <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
                  {r}
                </li>
              ))}
            </ul>
          </div>

          {hasLink ? (
            <a href={activeReg.url} target="_blank" rel="noreferrer" data-testid="ppdb-register-link">
              <Button className="w-full gap-2 bg-emerald-700 hover:bg-emerald-800" data-testid="ppdb-daftar-button">
                Daftar Sekarang <ExternalLink className="h-4 w-4" />
              </Button>
            </a>
          ) : (
            <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-4 text-center text-sm text-slate-500" data-testid="ppdb-placeholder">
              Link pendaftaran (Google Form) belum tersedia. Silakan hubungi pihak madrasah atau cek kembali secara berkala.
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PpdbDialog;
